import React, { Component } from "react";
import { logout } from "../../../lib/logout.js";
import commonFunction from "../../../lib/utils/common.js";
import getCurrencyList from "../../../lib/getCurrencyList.js";
import Link from "next/link.js";
import CurrencyListSection from "../../../componentsV2/currency";

class MobileHeader12 extends Component {
  handleLogout = () => {
    logout()
      .then((responseJSON) => {
        if (
          responseJSON.status === true ||
          responseJSON.message === "Logout successfull"
        ) {
          window.location.reload();
        }
      })
      .catch((err) => { });
  };

  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      showLoginSheet: false,
      selectedMenuKey: null,
      isClosing: false,
      openCurrencyPopup: false,
      currency: commonFunction.getCookieTocken("selectedCurrency"),
      currencyOptions: props?.data?.siteData?.site?.currencies || [],
      currencyOptionsPopular: [],
      currencyOptionsOther: [],
      openLogoutPopup: false,
    };
    this.sidebarRef = React.createRef();
    this.loginSheetRef = React.createRef();
  }

  openSidebar = () => {
    this.setState({ sidebarOpen: true });
  };

  closeSidebar = () => {
    this.setState({ isClosing: true });
    setTimeout(() => {
      this.setState({ sidebarOpen: false, isClosing: false });
    }, 300);
  };

  handleOutsideClick = (e) => {
    if (
      this.state.sidebarOpen &&
      this.sidebarRef.current &&
      !this.sidebarRef.current.contains(e.target)
    ) {
      this.closeSidebar();
    }
  };

  handleLoginRegisterClick = () => {
    this.setState({ showLoginSheet: true, sidebarOpen: true });
  };

  closeLoginSheet = () => {
    this.setState({ showLoginSheet: false });
  };

  handleLoginSheetOutsideClick = (e) => {
    if (
      this.state.showLoginSheet &&
      this.loginSheetRef.current &&
      !this.loginSheetRef.current.contains(e.target)
    ) {
      this.closeLoginSheet();
    }
  };

  handleLoginSheetAction = (action) => {
    this.closeLoginSheet();

    if (action === "login") {
      this.props?.data?.onClickHeaderLogin("LoginWithMobile");
    } else if (action === "Vendor_login") {
      this.props?.data?.onClickHeaderLogin("vendor_login");
    } else if (action === "register") {
      this.props?.data?.onClickHeaderLogin("Register");
    }
  };

  async componentDidMount() {
    const response = await getCurrencyList();

    // if (response?.status) {
    //   this.setState({
    //     currencyOptionsPopular: response.data.data.popular || [],
    //     currencyOptionsOther: response.data.data.other || []
    //   });
    // }

    // const savedCurrency = localStorage.getItem("selectedCurrency");
    // if (savedCurrency) {
    //   this.setState({ currency: savedCurrency });
    // }

    if (response?.status) {
      const popular = response.data.data.popular || [];
      const other = response.data.data.other || [];

      const activeCurrency =
        popular.find(c => c.status === "active") ||
        other.find(c => c.status === "active") ||
        popular[0] || other[0];


      this.setState({
        currencyOptionsPopular: popular,
        currencyOptionsOther: other,
        currency: activeCurrency?.code || ""
      });

      if (activeCurrency && !commonFunction.getCookieTocken("selectedCurrency")) {
        commonFunction?.setCookie("selectedCurrency", activeCurrency.code);
        commonFunction?.setCookie("selectedCurrencyName", activeCurrency.name);
      }

    }

    const savedCurrency = commonFunction.getCookieTocken("selectedCurrency");
    if (savedCurrency) {
      this.setState({ currency: savedCurrency });
    }



    document.addEventListener("mousedown", this.handleOutsideClick);
    document.addEventListener("mousedown", this.handleLoginSheetOutsideClick);

    window.addEventListener("currencyChanged", this.updateCurrencyFromStorage);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
    document.removeEventListener(
      "mousedown",
      this.handleLoginSheetOutsideClick
    );
    window.removeEventListener("currencyChanged", this.updateCurrencyFromStorage);
  }

  handleCurrencySelect = (code, name) => {
    commonFunction.setCookie("selectedCurrency", code);
    commonFunction.setCookie("selectedCurrencyName", name);
    this.setState({
      currency: code,
      openCurrencyPopup: false
    });
    window.dispatchEvent(new Event("currencyChanged"))
    window.location.reload();
  };

  updateCurrencyFromStorage = () => {
    const code = commonFunction.getCookieTocken("selectedCurrency");
    const name = commonFunction.getCookieTocken("selectedCurrencyName");

    this.setState({
      currency: code,
      currencyName: name
    });
  };

  render() {
    const isMobile = this.props.data?.isMobile;
    const styles = this.props.data.cssfile;
    const currentPath = window.location.pathname;
    const isConfirmationPage = currentPath.startsWith("/hotel/confirmation");
    const hideFullHeader = ["/registration", "/progress", "/vendor"].includes(
      currentPath
    );

    const sidebarMenu = [
      { key: "transactions", label: "My Bookings", icon: "booking-db.svg" },
      { key: "membership", label: "My BB-Pass Savings", icon: "bbpro_grey.svg" },
      { key: "favorites", label: "My Favorites", icon: "favorite.svg" },
      { key: "profile", label: "My Profile", icon: "profile-db.svg" },
      { key: "settings", label: "My Settings", icon: "setting-db.svg" },
    ];

    const sidebarMenuBottom = [
      { key: "help", label: "Help", icon: "help_grey.svg" },
      { key: "logout", label: "Logout", icon: "logout-db.svg" },
    ];
   

// const LogOut = ({ onClose, onLogout, styles }) => {
//   return (
//     <div className={styles.logout_overlay} onClick={onClose}>
//       <div className={styles.logout_modal} onClick={(e) => e.stopPropagation()}>
//         <div className={styles.logout_content}>
//           <div className={styles.logout_icon}>
//             <img src="/images/modal_logout.svg" alt="Lock icon" />
//           </div>
//           <div className={styles.logout_text_container}>
//             <h2 className={styles.logout_title}>Ready to Leave?</h2>
//             <p className={styles.logout_description}>
//               You'll be signed out of your account.{"\n"}
//               You can always log back in anytime.
//             </p>
//           </div>
//         </div>
//         <div className={styles.logout_footer}>
//           <button type="button" className={styles.logout_btn_stay} onClick={onClose}>
//             Stay Logged In
//           </button>
//           <button type="button" className={styles.logout_btn_logout} onClick={onLogout}>
//             Log Out
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

    // const sidebarMenuGuest = [
    //   { key: "about", label: "About Us", icon: "person_grey.svg" },
    //   { key: "contact", label: "Contact Us", icon: "globe_grey.svg" },
    //   { key: "help", label: "Help", icon: "help_grey.svg" },
    //   { key: "managebooking", label: "Manage Booking", icon: "manage_booking_grey.svg" },
    // ];

    const sidebarMenuGuest = [
      {
        key: "about",
        label: "About Us",
        icon: "person_grey.svg",
        route: "/about-us",
      },
      {
        key: "contact",
        label: "Contact Us",
        icon: "globe_grey.svg",
        route: "/contact-us",
      },
      {
        key: "help",
        label: "Help",
        icon: "help_grey.svg",
        route: "/faq"
      },
      {
        key: "managebooking",
        label: "Manage Booking",
        icon: "manage_booking_grey.svg",
        action: "managebooking",
      }
    ];


    return isMobile && hideFullHeader ? null : (
      <>
        <header className={styles.header_mob}>
          <div className={styles.header_mob__container}>
            {/* LEFT SECTION: Logo + BB Pass */}
            <div className={styles.header_mob__left}>
              <div className={styles.header_mob__logo}>
                <Link href="/">
                  <img
                    src={`/shared/api/media/${this.props?.data?.siteData?.data?.site_id}/${this.props?.data?.siteData?.data?.header?.mobile?.logo}`}
                    alt="logo"
                  />
                </Link>
              </div>
              
              {!isConfirmationPage && this.props?.data?.siteData?.site?.allow_member_subscription && (
                <div className={styles.bb_pass_wrapper}>
                  <div className={styles.header_mob_new_img}>
                    <img
                      src="images/logoNew.svg"
                      alt="LogoBlack"
                    />
                  </div>

                  <Link href="/membership">
                    <div className={styles.bb_pass_heading}>
                      BB-Pass Membership
                    </div>
                  </Link>
                </div>
              )}




            </div>

            {/* RIGHT SECTION: Currency + Menu */}
            {!isConfirmationPage && (
              <div className={styles.header_mob__right}>
                <div
                  className={styles.header_mob__currency}
                  onClick={() =>
                    this.setState({
                      openCurrencyPopup: !this.state.openCurrencyPopup,
                    })
                  }
                >
                  <span>{this.state.currency}</span>
                  <img src="images/downarrow_black.svg" alt="Arrow" />
                </div>

                <button
                  className={`${styles.header_mob__menu} ${this.state.sidebarOpen
                    ? styles.hamburger_mob_menuHidden
                    : ""
                    }`}
                  aria-label="Open menu"
                  onClick={this.openSidebar}
                >
                  <img src="images/te_hamburger.svg" alt="Menu Icon" />
                </button>
              </div>
            )}

          </div>
        </header>


        {/* Currency popup (hidden on confirmation page) */}
        {!isConfirmationPage && this.state.openCurrencyPopup && (
          <div className={styles.curr_pop}>
            <div
              onClick={() => this.setState({ openCurrencyPopup: false })}
              className={styles.curr_header}
            >
              <img src="/images/curr_header_back.svg" /> Currency
            </div>

            <div className={styles.curr_Popup_body}>
              <CurrencyListSection
                isMobile={true}
                title="Popular currencies"
                list={this.state.currencyOptionsPopular}
                activeCurrency={this.state.currency}
                styles={this.props.data.cssfile}
                onSelectCurrency={this.handleCurrencySelect}
              />
              <CurrencyListSection
                isMobile={true}
                title="Other currencies"
                list={this.state.currencyOptionsOther}
                activeCurrency={this.state.currency}
                styles={this.props.data.cssfile}
                onSelectCurrency={this.handleCurrencySelect}
              />
            </div>

          </div>
        )}

        {/* Sidebar when user is logged in */}
        {this.props?.data?.user?.accessToken && this.props?.data?.user?.first_name ? (
          this.state.sidebarOpen && (
            <>
              <div
                className={`${styles.sidebar_mob_overlay} ${this.state.isClosing ? styles.sidebar_closing : "sidebar_open"
                  }`}
              ></div>
              <div
                className={`${styles.sidebar_mob} ${styles.sidebar_mob_loggedin} ${this.state.isClosing ? styles.sidebar_closing : "sidebar_open"
                  }`}
              >
                <div className={styles.sidebar__profile}>
                  <div className={styles.sidebar__avatar}>
                    <img
                      src="images/user_white.svg"
                      alt="User Avatar"
                      className={styles.sidebar__avatar_img}
                    />
                  </div>
                  <div className={styles.sidebar__info}>
                    <div className={styles.sidebar__name}>
                      {this.props?.data?.user?.first_name}
                    </div>
                    <div className={styles.sidebar__info_membership}>
                      <img src="images/membership.svg" alt="Membership Icon" />
                      <span className={styles.sidebar__info_membership_text}>Visa Free BB-Pass Member</span>
                    </div>
                  </div>
                  <button
                    className={styles.sidebar_mob__close}
                    aria-label="Close sidebar"
                    onClick={this.closeSidebar}
                  >
                    <img src="images/tclose.svg" alt="Close" />
                  </button>
                </div>
                <nav className={styles.sidebar__nav}>
                  <ul className={styles.sidebar__menu}>
                    {sidebarMenu.map((item) => (
                      <li
                        key={item.key}
                        className={`${styles.sidebar__item} ${this.state.selectedMenuKey === item.key
                          ? styles.sidebar__item_active
                          : ""
                          }`}
                        onClick={() => {
                          this.setState({ selectedMenuKey: item.key });
                          if (item.key === "logout") {
                            this.handleLogout();
                          } else {
                            window.location.href = `/myprofile?activeTab=${item.key}`;
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <span className={styles.sidebar__icon}>
                          <img src={`images/${item.icon}`} alt={item.label} />
                        </span>
                        <span className={styles.sidebar__label}>
                          {item.label}
                        </span>
                      </li>
                    ))}
                  </ul>
                    {/* Separated bottom menu items */}
                  <ul className={`${styles.sidebar__menu_bottom}`}>
                    {sidebarMenuBottom.map((item) => (
                      <li
                        key={item.key}
                        className={`${styles.sidebar__item} ${this.state.selectedMenuKey === item.key
                          ? styles.sidebar__item_active
                          : ""
                          }`}
                        onClick={() => {
                          this.setState({ selectedMenuKey: item.key });
                          if (item.key === "logout") {
                            this.handleLogout();
                          } else if (item.key === "help") {
                            window.location.href = "/faq";
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <span className={styles.sidebar__icon}>
                          <img src={`images/${item.icon}`} alt={item.label} />
                        </span>
                        <span className={styles.sidebar__label}>
                          {item.label}
                        </span>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </>
          )
        ) : (
          <>
            {this.state.sidebarOpen && (
              <>
                <div
                  className={`${styles.sidebar_mob_overlay} ${this.state.isClosing
                    ? styles.sidebar_closing
                    : "sidebar_open"
                    }`}
                ></div>
                <div
                  className={`${styles.sidebar_mob} ${this.state.isClosing
                    ? styles.sidebar_closing
                    : "sidebar_open"
                    }`}
                  ref={this.sidebarRef}
                >
                  <div className={styles.sidebar_mob__header}>
                    <button
                      className={styles.sidebar_mob__close}
                      aria-label="Close sidebar"
                      onClick={this.closeSidebar}
                    >
                      <img src="images/tclose.svg" alt="Close" />
                    </button>
                    <div
                      className={styles.sidebar_mob__account}
                      onClick={this.handleLoginRegisterClick}
                      style={{ cursor: "pointer" }}
                    >
                      <div
                        className={styles.sidebar_mob__account_icon}>
                        <img
                          src="images/user_white.svg"
                          alt="Account"
                          className={styles.sidebar_mob__account_img}
                        />

                      </div>
                      <button
                        className={styles.sidebar_mob__account_text}
                        onClick={() => {
                          if (window.location.pathname !== "/login") {
                            const currentPath =
                              window.location.pathname + window.location.search;

                            sessionStorage.setItem("postLoginRedirect", currentPath);
                          }
                          this.props.data.onClickHeaderLogin("LogIn");
                        }}
                      >
                        Login / Register
                      </button>
                    </div>
                  </div>
                  <nav className={styles.sidebar__nav}>
                    <ul className={styles.sidebar__menu}>
                      {sidebarMenuGuest.map((item) => (
                        <li
                          key={item.key}
                          className={`${styles.sidebar__item} ${this.state.selectedMenuKey === item.key
                            ? styles.sidebar__item_active
                            : ""
                            }`}
                          // onClick={() => {
                          //   this.setState({ selectedMenuKey: item.key });

                          //   window.location.href = `/myprofile?activeTab=${item.key}`;

                          // }}
                          onClick={() => {
                            this.setState({ selectedMenuKey: item.key });

                            // Manage booking → Login/Register
                            if (item.action === "managebooking") {
                              // this.closeSidebar();
                              // this.handleLoginRegisterClick();
                              // return;
                              this.props.data?.handleManageBooking(true)
                            }

                            // Normal navigation
                            if (item.route) {
                              this.closeSidebar();
                              window.location.href = item.route;
                            }
                          }}

                          style={{ cursor: "pointer" }}
                        >
                          <span className={styles.sidebar__icon}>
                            <img src={`images/${item.icon}`} alt={item.label} />
                          </span>
                          <span className={styles.sidebar__label}>
                            {item.label}
                          </span>
                        </li>
                      ))}
                    </ul>
                    {/* <SidebarVersion styles={styles} /> */}
                  </nav>
                </div>
              </>
            )}
          </>
        )}
        {/* {this.state.openLogoutPopup && (
          <LogOut
            onClose={() => this.setState({ openLogoutPopup: false })}
            onLogout={this.handleLogout}
            styles={styles}
          />
        )} */}
      </>
    );
  }
}

function SidebarVersion({ styles }) {
  return <div className={styles.sidebar__version}>App Version 1.0.0</div>;
}

export default MobileHeader12;
